<template>
  <div class="app-page-wrapper absolute">
    <div class="advent w-full h-full">
      <header class="advent-header">
        <div class="advent-header-lights" />
        <div class="advent-header-lights" />
        <div class="advent-header-logo" />
      </header>

      <main v-if="windows.length" class="w-full relative flex justify-center items-center">
        <section class="advent-calendar">
          <tippy
            v-for="(window, index) in windows"
            :key="index"
            theme="WSM1"
            placement="top"
            max-width="50rem"
          >
            <calendar-window :calendar-window="window" />

            <template v-if="window.status === futureStatus" #content>
              <div class="lock-tooltip">
                <div class="lock-tooltip-title flexing">
                  <p class="uppercase font-medium text-30">
                    {{ $t('event.locked') }}
                  </p>
                </div>
                <div
                  class="lock-tooltip-info px-12 py-6"
                  v-html="
                    $replacePlaceholder(
                      $replaceHtmlPlaceholders(
                        $replacePlaceholder(
                          $t('event.locked_tooltip'),
                          '{number}',
                          '{b}{number}{/b}',
                        ),
                        'b',
                        'text-texts-standard-important',
                      ),
                      '{number}',
                      window.order,
                    )
                  "
                />
              </div>
            </template>
          </tippy>
        </section>

        <reward-detail />
      </main>

      <!-- <component-loading :is-loading="!windows" /> -->
      <video-ad-web v-show="getWebVideoPlaying" @hide-video="setWebVideoPlay(false)" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'pinia'
import { useAdventCalendarStore } from '@/store/pinia/events/adventCalendarStore'
import CalendarWindow from '@/components/AdventCalendar/CalendarWindow.vue'
import RewardDetail from '@/components/AdventCalendar/RewardDetail.vue'
import { WindowStatus } from '@/interfaces/events/AdventCalendar'
import { usePremiumStore } from '@/store/pinia/premiumStore'
import VideoAdWeb from '@/components/Premium/Ads/VideoAdWeb.vue'

export default defineComponent({
  name: 'AdventCalendarView',

  components: {
    CalendarWindow,
    RewardDetail,
    VideoAdWeb,
  },

  computed: {
    ...mapState(useAdventCalendarStore, ['windows']),
    ...mapState(usePremiumStore, ['getWebVideoPlaying']),

    futureStatus(): WindowStatus {
      return WindowStatus.Future
    },
  },

  created() {
    this.loadCalendar()
  },

  methods: {
    ...mapActions(useAdventCalendarStore, ['loadCalendar']),
    ...mapActions(usePremiumStore, ['setWebVideoPlay']),
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/views/advent-calendar/calendar.scss';
</style>
